/* ============================================================
   zeromode - scroll reveal engine (product cards only)
   Product cards rise + fade in one-by-one as they scroll into
   view. Cards that enter together cascade left-to-right.

   To change the gap between cards, edit STAGGER_MS below
   (e.g. 400 = slow 0.4s gap, 120 = snappy). Bigger = more
   separation between each card.
   ============================================================ */
(function () {
  'use strict';

  // Gap (in milliseconds) between each card in a cascade.
  var STAGGER_MS = 220;

  // Respect reduced-motion: do nothing, leave all content visible.
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  // No IntersectionObserver (very old browsers): leave content visible.
  if (!('IntersectionObserver' in window)) {
    return;
  }

  var root = document.documentElement;

  // Only product cards cascade - nothing else animates.
  var ITEM_SELECTOR = '.product-grid__item, .resource-list__item';

  var observer = new IntersectionObserver(function (entries) {
    // Cascade everything that became visible in THIS batch, in DOM order.
    var visible = entries.filter(function (e) { return e.isIntersecting; });
    if (!visible.length) return;

    visible.sort(function (a, b) {
      var pos = a.target.compareDocumentPosition(b.target);
      return (pos & Node.DOCUMENT_POSITION_FOLLOWING) ? -1 : 1;
    });

    visible.forEach(function (entry, i) {
      entry.target.style.setProperty('--zm-delay', (i * STAGGER_MS) + 'ms');
      entry.target.classList.add('zm-in');
      observer.unobserve(entry.target);
    });
  }, {
    threshold: 0.12,
    rootMargin: '0px 0px -8% 0px'
  });

  function tagAndObserve(scope) {
    scope.querySelectorAll(ITEM_SELECTOR).forEach(function (item) {
      if (item.classList.contains('zm-reveal')) return;
      item.classList.add('zm-reveal');
      observer.observe(item);
    });
  }

  function init() {
    // Scope to main content so header, nav, and footer are untouched.
    var main = document.getElementById('MainContent') || document.body;
    root.classList.add('zm-reveal-enabled');
    tagAndObserve(main);
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }

  // Shopify theme editor: re-scan when a section is added or reloaded.
  document.addEventListener('shopify:section:load', function (event) {
    if (!root.classList.contains('zm-reveal-enabled')) {
      root.classList.add('zm-reveal-enabled');
    }
    tagAndObserve(event.target || document.getElementById('MainContent') || document.body);
  });
})();

/* ============================================================
   zeromode - hide the bottom blur when the footer is in view
   so the footer stays fully sharp/readable. Runs independently
   of reduced-motion (it only toggles visibility).
   ============================================================ */
(function () {
  'use strict';

  function start() {
    var blur = document.querySelector('.zm-bottom-blur');
    var footer = document.querySelector('footer');
    if (!blur || !footer || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        blur.classList.toggle('zm-hide', entry.isIntersecting);
      });
    }, { threshold: 0 });

    io.observe(footer);
  }

  if (document.readyState !== 'loading') {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start);
  }
})();
